module.exports = __webpack_public_path__ + "img/img_paperMaterial4_test.65cbc0fd.png";